import acb from './images/acb.jpg';
import vfd from './images/GA700.png';
import ladder from './images/ladder.png';
import iot from './images/iot.png';
import acbWork from './images/works/acbWork.jpg';
import ropeway from './images/works/ropeway.png';
import powerMgmt from './images/works/pwmanage.jpg';
import lnt from './images/lnk.png';
import yaskawa from './images/yaskawa.png';
import havells from './images/havells.png';

export const company = {
  name: 'Anuryan E & A Pvt. Ltd.',
  phone: '+91 9051024015',
  phoneHref: 'tel:+919051024015',
  email: 'service@anuryan.com',
  address: 'Sucharu Villa, 374/1, 4th Rd, Ajoy Nagar, Santoshpur, Kolkata, West Bengal 700075',
  founded: 2000,
};

export const services = [
  {
    id: 'acb',
    n: '01',
    title: 'ACB Servicing',
    short: 'Air Circuit Breaker maintenance',
    text: 'Preventive and breakdown maintenance of Air Circuit Breakers, so your incomer and feeder panels trip when they should and stay closed when they should.',
    points: ['Contact & arc-chute inspection', 'Mechanism cleaning & lubrication', 'Trip unit testing & settings', 'Panel health report'],
    image: acb,
  },
  {
    id: 'vfd',
    n: '02',
    title: 'VFD Installation & Commissioning',
    short: 'Variable Frequency Drives',
    text: 'Installation, parameterisation and commissioning of drives for smoother motor control and lower energy use.',
    points: ['Drive setup & parameter tuning', 'Motor & load matching', 'Panel wiring & testing', 'Operator handover & training'],
    image: vfd,
    contain: true,
  },
  {
    id: 'plc',
    n: '03',
    title: 'PLC & HMI Programming',
    short: 'Control logic and operator screens',
    text: 'Custom control systems with clear operator interfaces, built around how your plant actually runs.',
    points: ['Ladder / structured logic', 'HMI screens & alarms', 'Site commissioning', 'Documentation & backups'],
    image: ladder,
    contain: true,
  },
  {
    id: 'iot',
    n: '04',
    title: 'Digitization & Industrial IoT',
    short: 'See your plant from anywhere',
    text: 'Remote monitoring and control through IIoT: connect machines, collect the data, and turn it into dashboards and alerts you can act on.',
    points: ['Machine data acquisition', 'Live dashboards', 'Alarms & notifications', 'Energy & process visibility'],
    image: iot,
    contain: true,
  },
];

export const industries = ['Cement', 'Rubber', 'Food & Beverage', 'Minerals', 'Plastics', 'Hotels', 'Hospitals', 'Oil & Gas', 'Metals'];

export const works = [
  { title: 'Power Management System', text: 'Automatic switch-over power management system for a reputed multispecialty hospital.', tag: 'PLC · Power', image: powerMgmt },
  { title: 'ACB Maintenance', text: 'Regular maintenance of Air Circuit Breakers at a factory.', tag: 'ACB', image: acbWork },
  { title: 'Ropeway Automation', text: 'Automatic operation of ropeway transport.', tag: 'Automation', image: ropeway },
];

export const partners = [
  { name: 'L&T', image: lnt },
  { name: 'Yaskawa', image: yaskawa },
  { name: 'Havells', image: havells },
];

export const process = [
  { t: 'Survey', d: 'Site visit, panel and process study.' },
  { t: 'Design', d: 'Scope, drawings and a clear quote.' },
  { t: 'Install', d: 'Supply, wiring and programming.' },
  { t: 'Commission', d: 'Testing, tuning and handover.' },
  { t: 'Support', d: 'Maintenance and quick service.' },
];
